module.exports = __webpack_public_path__ + "img/9_industry_innovation_and_infrastructure.b0b15425.svg";